import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CountLinesStatuses } from '../../sim-and-line-management/sim-and-line-management.models';

@Component({
  selector: 'app-list-lines-by-status',
  templateUrl: './list-lines-by-status.component.html',
  styleUrls: ['./list-lines-by-status.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListLinesByStatusComponent {
  CREATE_GROUP_SELECT_ACCOUNT_FORM_PREFIX =
    'PAGE.MOBILE.GROUPS.GROUPS_MANAGEMENT.CREATE_GROUP.SELECT_ACCOUNTS.';

  _countLinesStatuses: CountLinesStatuses;
  totalLines: number;
  lineStatusList: string[];

  @Input() emptyText: string;

  get countLinesStatuses(): CountLinesStatuses {
    return this._countLinesStatuses;
  }

  @Input() set countLinesStatuses(countLinesStatuses: CountLinesStatuses) {
    this._countLinesStatuses = countLinesStatuses;
    this.setTotalLines();
    this.setLineStatusList();
  }

  setTotalLines() {
    this.totalLines = 0;
    for (let status of Object.keys(this.countLinesStatuses)) {
      this.totalLines = this.totalLines + this.countLinesStatuses[status];
    }
  }

  setLineStatusList() {
    this.lineStatusList = Object.keys(this.countLinesStatuses);
  }
}
